import React from 'react'
import { TextareaAutosize } from '@material-ui/core/'
import c from 'classnames'
import arrowMessage from '../../../../../../assetss/img/arrowMessage.svg'
import closeEdit from '../../../../../../assetss/img/closeEdit.svg'
import './index.scss'

const ChatInput = ({ onChange, value, onSubmit, editTextMess, onCloseEdit }) => {
  return (
    <div className={c('customInputChatBox', editTextMess && 'customInputChatBoxHeight')}>
      <div className='inputContainer'>
        {editTextMess && <img src={closeEdit} onClick={onCloseEdit} className='canselIconEdit' />}
        <TextareaAutosize
          onChange={onChange}
          value={value}
          className={c('customInputChat', editTextMess && 'newTextEdit')}
          rowsMax={4}
          placeholder='Write your message here'
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onSubmit()
              e?.preventDefault()
            }
          }}
        />
        {!editTextMess && <img className='arrowMessage' src={arrowMessage} onClick={onSubmit} />}
      </div>
      {editTextMess && (
        <div className='editMessContainer'>
          <div className='textEdit'>{editTextMess}</div>
          <img className='arrowMessage' src={arrowMessage} onClick={onSubmit} />
        </div>
      )}
    </div>
  )
}

export default ChatInput
